const defaultConfig = {
  exitDelay: 400,
  interval: 100,
  sensitivity: 7
}

// A Class to provide hoverIntent functionality to a set of elements. Prevents mouse over from over-firing, or firing too eagerly.

export class HoverIntent {
  constructor (elements, userConfig) {
    this.config = this.combineConfig(userConfig)
    this.currX = 0
    this.currY = 0
    this.prevX = 0
    this.prevY = 0
    this.allElems = elements
    this.pollTimer = ''
    this.exitTimer = ''
    this.init()
  }

  combineConfig (userConfig) {
    const result = defaultConfig
    for (const i in userConfig) {
      result[i] = userConfig[i]
    }
    return result
  }

  mouseTrack (ev) {
    this.currX = ev.pageX
    this.currY = ev.pageY
  }

  mouseCompare = (targetElem) => {
    const distX = this.prevX - this.currX
    const distY = this.prevY - this.currY
    const distance = Math.sqrt(distX * distX + distY * distY)

    if (distance < this.config.sensitivity) {
      // if we re-entered an element, cancel delayed exit and clear any active elements immediately
      clearTimeout(this.exitTimer)
      for (const elem of this.allElems) {
        if (elem.isActive) {
          this.config.onExit(elem)
          elem.isActive = false
        }
      }

      // trigger hover
      this.config.onEnter(targetElem)
      targetElem.isActive = true
    } else {
      // update previous coordinates and try again later
      this.prevX = this.currX
      this.prevY = this.currY
      this.pollTimer = setTimeout(() => {
        this.mouseCompare(targetElem)
      }, this.config.interval)
    }
  }

  init () {
    for (const elem of this.allElems) {
      elem.isActive = false
      elem.addEventListener('mousemove', this.mouseTrack)
      elem.addEventListener('mouseenter', (ev) => {
        this.prevX = ev.pageX
        this.prevY = ev.pageY
        if (elem.isActive) {
          clearTimeout(this.exitTimer)
          return
        }
        this.pollTimer = setTimeout(() => {
          this.mouseCompare(elem)
        }, this.config.interval)
      })
      elem.addEventListener('mouseleave', (ev) => {
        clearTimeout(this.pollTimer)
        if (!elem.isActive) {
          return
        }
        this.exitTimer = setTimeout(() => {
          this.config.onExit(elem, ev)
          elem.isActive = false
        }, this.config.exitDelay)
      })
    }
  }
}

export function setupHoverIntent (elements, userConfig) {
  const hoverIntents = []
  hoverIntents.push(new HoverIntent(elements, userConfig))

  return hoverIntents
}
